import Modal from "../../CommonComponents/common/modal/Modal";
import DataTable from "../../CommonComponents/common/datatable/DataTable";
import { Box } from "@mui/material";

const MonetaryImpactModal = ({ open, handleClose, rows = [], columns = [] }) => {
  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title="Monetary Impact"
      initialWidth={1100}
      initialHeight={600}
      content={
        <DataTable
          columns={columns}
          rows={rows}
          height="100%"
          defaultPageSize={10}
          loading={rows.length === 0}
        />
      }
      action={
        <Box display="flex" justifyContent="flex-end" width="100%">
          <button className="btn btn-primary" onClick={handleClose}>
            Close
          </button>
        </Box>
      }
    />
  );
};

export default MonetaryImpactModal;
